import React, { Component } from "react";
import { Button } from "@maxmilhas/hangar-components-atomic/public"
import {
    is
} from "ramda";

export default class DetailsButton extends Component {
    constructor(props) {
        super(props);
    }

    handleShowDetails = () => {
        const { onShowDetails } = this.props;
        if(is(Function, onShowDetails)) {
            onShowDetails();
        }
    }

    render() {
        return (            
            <Button 
                onClick={this.handleShowDetails}
                size="small" 
                color="green"
                outline={""}
                title="Detalhes"
                data-action="my-trips-details-button">
                    Detalhes
            </Button>
        );
    }
}